import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = '/api';
const RED = '#b91d47', RED_D = '#8f1538', INK = '#1c1c28', GREY = '#7a7a8c', STAR = '#ff8a00';

export default function AppReviews() {
  const navigate = useNavigate();
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const phone = localStorage.getItem('userPhone') || '';
        // Reviews given by this customer — try dedicated endpoint, else empty
        try {
          const r = await axios.get(`${API}/reviews/customer/${phone}`, { timeout: 10000 });
          setReviews(Array.isArray(r.data) ? r.data : []);
        } catch (e) { setReviews([]); }
      } catch (e) { setReviews([]); }
      setLoading(false);
    };
    load();
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#f4f6fb', maxWidth: 480, margin: '0 auto' }}>
      <div style={{ background: `linear-gradient(135deg,${RED},${RED_D})`, color: '#fff', padding: '20px 16px', display: 'flex', alignItems: 'center', gap: 14 }}>
        <span onClick={() => navigate('/app/profile')} style={{ fontSize: 24, cursor: 'pointer' }}>‹</span>
        <div style={{ fontSize: 18, fontWeight: 700 }}>My Reviews</div>
      </div>
      <div style={{ padding: 16 }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: 40, color: GREY }}>Loading...</div>
        ) : reviews.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 50, color: GREY }}>
            <div style={{ fontSize: 50 }}>⭐</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: INK, marginTop: 12 }}>No reviews yet</div>
            <div style={{ fontSize: 13, marginTop: 6 }}>After a visit, you can rate the salon.<br />Your reviews will appear here.</div>
          </div>
        ) : (
          reviews.map((r, i) => (
            <div key={i} style={{ background: '#fff', borderRadius: 14, padding: 16, marginBottom: 12, boxShadow: '0 2px 8px rgba(28,28,40,.05)' }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: INK }}>{r.salon_name || 'Salon'}</div>
              <div style={{ color: STAR, fontSize: 14, margintop: 4 }}>{'★'.repeat(Math.round(r.rating || 5))}{'☆'.repeat(5 - Math.round(r.rating || 5))}</div>
              <div style={{ fontSize: 13, color: GREY, marginTop: 6, lineHeight: 1.5 }}>{r.review_text || ''}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
